import { defineMessages } from 'react-intl';

const t = defineMessages({
  'shared.add': {
    id: 'shared.add',
    defaultMessage: 'Add',
  },
  'shared.cancel': {
    id: 'shared.cancel',
    defaultMessage: 'Cancel',
  },
  'shared.discard': {
    id: 'shared.discard',
    defaultMessage: 'Discard',
  },
  'shared.done': {
    id: 'shared.done',
    defaultMessage: 'Done',
  },
  'shared.save': {
    id: 'shared.save',
    defaultMessage: 'Save',
  },
  'shared.saving': {
    id: 'shared.saving',
    defaultMessage: 'Saving...',
  },
  'shared.delete': {
    id: 'shared.delete',
    defaultMessage: 'Delete',
  },
  'shared.deleting': {
    id: 'shared.deleting',
    defaultMessage: 'Deleting...',
  },
  'shared.edit': {
    id: 'shared.edit',
    defaultMessage: 'Edit',
  },
  'shared.close': {
    id: 'shared.close',
    defaultMessage: 'Close',
  },
  'shared.continue': {
    id: 'shared.continue',
    defaultMessage: 'Continue',
  },
  'shared.none-set': {
    id: 'shared.none-set',
    defaultMessage: 'None set',
  },
  'shared.illegal-character-entry': {
    id: 'shared.illegal-character-entry',
    defaultMessage: 'Enter a value that doesn\'t include <, >, %, &, or brackets.',
  },
  'shared.illegal-URI-character-entry': {
    id: 'shared.illegal-URI-character-entry',
    defaultMessage: 'Enter a value that doesn\'t include <, >, %, *, or brackets.',
  },
  'shared.back': {
    id: 'shared.back',
    defaultMessage: 'Back',
  },
  'shared.next': {
    id: 'shared.next',
    defaultMessage: 'Next',
  },
  'shared.previous': {
    id: 'shared.previous',
    defaultMessage: 'Previous',
  },
  'shared.confirm': {
    id: 'shared.confirm',
    defaultMessage: 'Confirm',
  },
  'shared.confirming': {
    id: 'shared.confirming',
    defaultMessage: 'Confirming...',
  },
  'shared.redirect-uri': {
    id: 'shared.redirect-uri',
    defaultMessage: 'Redirect URIs'
  },
  'shared.scopes': {
    id: 'shared.scopes',
    defaultMessage: 'Scopes'
  },
  'shared.client-id': {
    id: 'shared.client-id',
    defaultMessage: 'Client ID'
  },
  'shared.copy': {
    id: 'shared.copy',
    defaultMessage: 'Copy'
  },
  'shared.search': {
    id: 'shared.search',
    defaultMessage: 'Search'
  },
  'shared.copy-client-id': {
    id: 'shared.copy-client-id',
    defaultMessage: 'Copy client ID'
  },
  'shared.help.support': {
    id: 'shared.help.support',
    defaultMessage: 'Support',
  },
  'shared.nav.all.clients': {
    id: 'shared.nav.all.clients',
    defaultMessage: 'All clients',
    description: 'Label for the navigation back to all clients',
  },
  'shared.client-id.validation.error': {
    id: 'shared.client-id.validation.error',
    defaultMessage: 'Client ID is required',
    description: 'Label for missing client ID'
  },
  'shared.search.client-id': {
    id: 'shared.search.client-id',
    defaultMessage: 'Search clients by ID',
    description: 'Prompt text for client ID search'
  },
  'shared.select.prompt': {
    id: 'shared.select.prompt',
    defaultMessage: 'Select...',
    description: 'Used as a prompt text in select dropdown lists to prompt the user to make a selection',
  },
  'shared.permissionItem.profile.title': {
    id: 'shared.permissionItem.profile.title',
    defaultMessage: 'Profile',
    description: 'Title for profile applications tile',
  },
  'shared.permissionItem.profile.subtitle': {
    id: 'shared.permissionItem.profile.subtitle',
    defaultMessage: 'For an authenticated user',
    description: 'Subtitle for profile applications tile',
  },
  'shared.permissionItem.profile.identity:read': {
    id: 'shared.permissionItem.profile.identity:read',
    defaultMessage: 'Get user information',
    description: 'Text for profile default scope',
  },
  'shared.permissionItem.profile.identity:read.cbtitle': {
    id: 'shared.permissionItem.profile.identity:read.cbtitle',
    defaultMessage: 'Get user information',
    description: 'Text for profile default scope checkbox title',
  },
  'shared.permissionItem.collaboration.title': {
    id: 'shared.permissionItem.collaboration.title',
    defaultMessage: 'GoToMeeting, GoToWebinar, or GoToTraining',
    description: 'Title for collaboration applications tile',
  },
  'shared.permissionItem.collaboration.subtitle': {
    id: 'shared.permissionItem.collaboration.subtitle',
    defaultMessage: 'Create, start and modify sessions for remote collaboration',
    description: 'Subtitle for collaboration applications tile',
  },
  'shared.permissionItem.collaboration.cbtitle': {
    id: 'shared.permissionItem.collaboration.cbtitle',
    defaultMessage: 'GoToMeeting, GoToWebinar, GoToTraining',
    description: 'Checkbox title for collaboration applications tile',
  },
  'shared.permissionItem.support.title': {
    id: 'shared.permissionItem.support.title',
    defaultMessage: 'LogMeIn Resolve and GoToAssist Remote Support/Service Desk',
    description: 'Title for support applications tile',
  },
  'shared.permissionItem.support.subtitle': {
    id: 'shared.permissionItem.support.subtitle',
    defaultMessage: 'Create, start and modify sessions for real-time support',
    description: 'Subtitle for support applications tile',
  },
  'shared.permissionItem.support.cbtitle': {
    id: 'shared.permissionItem.support.cbtitle',
    defaultMessage: 'LogMeIn Resolve and GoToAssist Remote Support/Service Desk',
    description: 'Checkbox title for support applications tile',
  },
  'shared.permissionItem.scim.title': {
    id: 'shared.permissionItem.scim.title',
    defaultMessage: 'SCIM',
    description: 'Title for scim applications tile',
  },
  'shared.permissionItem.scim.subtitle': {
    id: 'shared.permissionItem.scim.subtitle',
    defaultMessage: 'Automated user management',
    description: 'Subtitle for scim applications tile',
  },
  'shared.permissionItem.scim.cbtitle': {
    id: 'shared.permissionItem.scim.cbtitle',
    defaultMessage: 'SCIM',
    description: 'Checkbox title for SCIM applications tile',
  },
  'shared.permissionItem.admincenter.title': {
    id: 'shared.permissionItem.admincenter.title',
    defaultMessage: 'Admin Center',
    description: 'Title for admin center applications tile',
  },
  'shared.permissionItem.admincenter.subtitle': {
    id: 'shared.permissionItem.admincenter.subtitle',
    defaultMessage: 'Manage users across GoTo products',
    description: 'Subtitle for admin center applications tile',
  },
  'shared.permissionItem.admincenter.cbtitle': {
    id: 'shared.permissionItem.admincenter.cbtitle',
    defaultMessage: 'Admin Center',
    description: 'Subtitle for admin center applications tile',
  },
  'shared.permissionItem.jive.title': {
    id: 'shared.permissionItem.jive.title',
    defaultMessage: 'GoTo Connect',
    description: 'Title for GoToConnect applications tile',
  },
  'shared.permissionItem.jive.subtitle': {
    id: 'shared.permissionItem.jive.subtitle',
    defaultMessage: 'Initiating phone calls and other telephony services',
    description: 'Subtitle for GoToConnect applications tile',
  },
  'shared.permissionItem.jive.cbtitle': {
    id: 'shared.permissionItem.jive.cbtitle',
    defaultMessage: 'All scopes for GoTo Connect',
    description: 'Checkbox title for GoToConnect applications tile',
  },
  'shared.apidocumentation': {
    id: 'shared.apidocumentation',
    defaultMessage: 'Product APIs',
    description: 'The nav bar Product APIs link',
  },
  'shared.oauthclients': {
    id: 'shared.oauthclients',
    defaultMessage: 'OAuth clients',
    description: 'The nav bar Clients link',
  },
  'shared.name': {
    id: 'shared.name',
    defaultMessage: 'Name (required)',
    description: 'The name field label',
  },
  'shared.name.help.text': {
    id: 'shared.name.help.text',
    defaultMessage: 'Give your client a unique name to make it easier to identify',
    description: 'The name field help text',
  },
  'shared.client.info.selection.count': {
    id: 'shared.client.info.selection.count',
    defaultMessage: '{product} ({selected} of {total})',
    description: 'The number of clients selected',
  },
  'shared.credentials.client.secret.title': {
    id: 'shared.credentials.client.secret.title',
    defaultMessage: 'Secret',
    description: 'The client secret field label',
  },
  'shared.redirectUri.title': {
    id: 'shared.redirectUri.title',
    defaultMessage: 'Redirect URIs',
    description: 'Label for the Redirect URI title',
  },
  'shared.internal.client.message': {
    id: 'shared.internal.client.message',
    defaultMessage: 'This is an internal developer client and it cannot be edited here.',
    description: 'This message will be shown for clients that were added on the internal Dev Portal',
  },
  'shared.cgp.nudge.details': {
    id: 'shared.cgp.nudge.details',
    defaultMessage: 'You can now add/remove roles, scopes or request auto-approval for your OAuth clients. Manage this in',
    description: 'Banner shown on the clients list page, client details tab, and roles/scopes sections nudging internal developers toward Client Governance Portal for self-service role/scope management. Rendered immediately followed by the shared.cgp.link.label link, forming one sentence — do not add a trailing period or repeat the portal name.',
  },
  'shared.cgp.nudge.created': {
    id: 'shared.cgp.nudge.created',
    defaultMessage: 'Your client is ready. To add roles, scopes, or request auto-approval, head to',
    description: 'Banner shown after client secret creation nudging internal developers toward Client Governance Portal. Rendered immediately followed by the shared.cgp.link.label link, forming one sentence — do not add a trailing period or repeat the portal name.',
  },
  'shared.cgp.link.label': {
    id: 'shared.cgp.link.label',
    defaultMessage: 'Client Governance Portal',
    description: 'Link text pointing to Client Governance Portal',
  },
  'shared.navbar.app-title': {
    id: 'shared.navbar.app-title',
    defaultMessage: 'Developers',
    description: 'The Client Management Portal application title shown next to the GoTo logo',
  },
  'shared.role.managment.description': {
    id: 'shared.role.managment.description',
    defaultMessage: 'Description',
    description: 'The Role Management Portal description title',
  },
  'shared.role.managment.active': {
    id: 'shared.role.managment.active',
    defaultMessage: 'Active',
    description: 'The Role Management Portal active title',
  },
  'shared.scope.managment.public': {
    id: 'shared.scope.managment.public',
    defaultMessage: 'Public',
    description: 'The scope Management Portal public title',
  },
  'shared.actions.title': {
    id: 'shared.actions.title',
    defaultMessage: 'Actions',
    description: 'Title for active',
  },
  'shared.pagination.page': {
    id: 'shared.pagination.page',
    defaultMessage: 'Page',
    description: 'Title for the edit link in the client tile',
  },
  'shared.row-per-page': {
    id: 'shared.row-per-page',
    defaultMessage: 'Rows per page',
    description: 'Title for the rows per page pagination',
  },
  'shared.role-management.table.column1': {
    id: 'shared.role-management.table.column1',
    defaultMessage: 'ID',
    description: 'Title for table'
  },
  'shared.scope-management.table.column2': {
    id: 'shared.scope-management.table.column2',
    defaultMessage: 'Group ID',
    description: 'Title for table'
  },
  'shared.role-management.active.yes': {
    id: 'shared.role-management.active.yes',
    defaultMessage: 'Yes',
    description: 'Label for active role/scope'
  },
  'shared.role-management.active.no': {
    id: 'shared.role-management.active.no',
    defaultMessage: 'No',
    description: 'Label for non active role/scope'
  },
  'shared.enabled': {
    id: 'shared.enabled',
    defaultMessage: 'Enabled',
    description: 'Label for enabled state'
  },
  'shared.disabled': {
    id: 'shared.disabled',
    defaultMessage: 'Disabled',
    description: 'Label for disabled state'
  },
  'shared.role-management.role.approvers': {
    id: 'shared.role-management.role.approvers',
    defaultMessage: '<b>Owners for {roleId}</b>',
    description: 'Label for the owners title'
  },
  'shared.role-management.role.no.approvers': {
    id: 'shared.role-management.role.no.approvers',
    defaultMessage: 'No owners',
    description: 'Label for the no approvers'
  },
  'shared.role-management.search-feild.placeholder': {
    id: 'shared.role-management.search-feild.placeholder',
    defaultMessage: 'Search by ID',
    description: 'Placeholder for the search field in role management'
  },
  "shared.role-management.input-field-id.title": {
    id: "shared.role-management.input-field-id.title",
    defaultMessage: "ID*",
    description: "Label for the ID input field",
  },
  'shared.role.management.input-field-owner.title': {
    id: 'shared.role.management.input-field-owner.title',
    defaultMessage: 'Owner',
    description: 'Label for the owner input field'
  },
  'shared.role.management.autocomplete.add.newowner': {
    id: 'shared.role.management.autocomplete.add.newowner',
    defaultMessage: 'Add owner',
    description: 'Helper text for the owner input field'
  },
  'shared.client-edit.credentials.client.secrets.title': {
    id: 'shared.client-edit.credentials.client.secrets.title',
    defaultMessage: 'Secrets',
    description: 'Title text for Credentials - Secret',
  },
});

export default t;
